import { when } from '@execonline-inc/maybe-adapter';
import clsx from 'clsx';
import { Maybe } from 'maybeasy';
import { LearningDesignResource } from '../../../../../../Types';

const selectLearningDesign = (
  selectedLearningDesignId: Maybe<number>,
  learningDesignResource: LearningDesignResource,
): Maybe<{}> =>
  selectedLearningDesignId.andThen((selectedLearningDesign) =>
    when(selectedLearningDesign == learningDesignResource.payload.id, {}),
  );

export const learningDesignCardStyle = (
  selectedLearningDesignId: Maybe<number>,
  learningDesignResource: LearningDesignResource,
): string =>
  clsx(
    'mb-6 flex cursor-pointer items-start bg-white p-6',
    selectLearningDesign(selectedLearningDesignId, learningDesignResource)
      .map(() => 'border-2 border-solid border-teal-400 bg-teal-500 bg-opacity-25')
      .getOrElseValue(''),
  );
